export default __webpack_public_path__ + "static/media/followUp2.4d118b66.png";